import { UtenteDTO } from "./utenteDTO";

export class ProcedimentoDTO {
  codice: string;
  nome: string;
  responsabile: UtenteDTO;
}
